module.exports = __webpack_public_path__ + "img/help_search.b648a77d.png";